import { render, staticRenderFns } from "./userDisplayWidge.vue?vue&type=template&id=16b89b86&scoped=true"
import script from "./userDisplayWidge.vue?vue&type=script&lang=js"
export * from "./userDisplayWidge.vue?vue&type=script&lang=js"
import style0 from "./userDisplayWidge.vue?vue&type=style&index=0&id=16b89b86&prod&lang=scss"
import style1 from "./userDisplayWidge.vue?vue&type=style&index=1&id=16b89b86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b89b86",
  null
  
)

export default component.exports